/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.30.0
 */

import styled from 'styled-components';

import { fonts } from '@/main/theme';

export const WizardCollationReportStepChooseStyled = styled.div.attrs({
    className: 'wizard-collation-report',
})`
    user-select: none;
    margin-top: 20px;
    max-width: 560px;

    .wizard-collation-report__title {
        ${fonts.textMainBold};
        margin-bottom: 16px;
    }

    .wizard-collation-report__subtitle {
        ${fonts.textMainBold};
        margin-bottom: 6px;
    }

    .wizard-collation-report__group-control {
        width: fit-content;
        margin-bottom: 24px;
    }
`;

export const WizardCollationReportStepConfirmationStyled = styled.div.attrs({
    className: 'wizard-collation-report',
})`
    display: grid;
    grid-template-columns: 1fr 1fr;

    margin-top: 20px;
`;

export const WizardCollationReportPeriodStyled = styled.div`
    width: 220px;
    margin-bottom: 16px;
`;
